<template>
  <div class="row">
    <div class="col-xl-12" v-show="statData.length">
      <div class="row">
        <div v-for="stat of statData" :key="stat.icon" class="col-md-3">
          <Stat :data="stat || []"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Stat from '@/components/widgets/statRoomlist'
import Swal from 'sweetalert2'
import 'vue-loading-overlay/dist/vue-loading.css'
import http from '@/http'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapActions, mapState, mapGetters } from 'vuex'
import service from '@/pages/settingscheckin/services'
import { EventBus } from '@/eventBus'

export default {
  components: { Stat },
  data () {
    return {
      settings: {
        has_checkout: false
      },
      filter: {},
      timeout: 60000,
      modal: false,
      statData: []
    }
  },
  beforeMount () {
    this.getSettingCheckin()
  },
  methods: {
    ...mapActions('tag', {
      getAll: 'getAll'
    }),
    ...mapActions('settingcheck', {
      settingsCheckin: 'getAll',
      resetCheckin: 'resetCheckin'
    }),
    openDetail (type) {
      this.$refs.modaldetail.open(type, this.filter)
      this.modal = true
    },
    applyFilter () {
      console.log(this.filter)
      this.getSubscribers()
      // if (typeof (this.selected) === 'object') {
      //   this.filter.district = this.selected.value
      // }
    },
    getSubscribers () {
      let params = {
        checkin_date: this.filter.checkin_date ? this.$moment(this.filter.checkin_date).format('YYYY-MM-DD') : null,
        tag: this.filter.tag
      }
      http.get(`/admin/metrics/roomlist`, { params }).then((response) => {
        this.statData = response.data
      }).catch((error) => {
        console.error(error)
      })
    },
    getTags () {
      let params = {
        search: this.search || null,
        limit: 100,
        page: 1
      }
      this.params = params
      this.getAll(this.params).then((res) => {
      }).catch(error => {
        console.log(error)
      })
    },
    getSettingCheckin () {
      let loader = this.$loading.show()
      this.settingsCheckin()
        .then(() => {
          this.settings = this.settingcheckin
        }).then(() => { loader.hide() })
        .catch((error) => {
          console.error(error)
          loader.hide()
          errorMessage('Atenção:' + error.message)
        })
    },
    cancelAutoUpdate () {
      clearInterval(this.timeout)
    },
    getSettings () {
      let loader = this.$loading.show()
      this.settings = this.settingcheckin
      loader.hide()
    },
    toggleControl (key, status) {
      if (status !== '') {
        let payload = {
          [key]: status ? 1 : 0
        }
        service.toogleSetting(payload)
          .then((data) => {
            successMessage('Sucesso: ' + data.data.message, 2500)
          }).catch((error) => {
            this.settings[key] = false
            errorMessage('Atenção: ' + error.message)
          })
      }
    },
    cleanCheckins () {
      Swal.fire({
        title: 'Você tem certeza?',
        html: `Todos os participantes que estão com status <b>check-in</b> serão marcados como <b>check-out</b>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#388741',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, MUDAR STATUS'
      }).then(result => {
        if (result.value) {
          try {
            this.resetCheckin().then((res) => {
              successMessage('Sucesso: Status atualizado.', 2500)
            }).then(() => {
              this.getSubscribers()
            }).catch((err) => {
              errorMessage('Alerta: ' + err.message)
            })
          } catch (err) {
            console.log(err)
          }
        }
      })
    }
  },
  computed: {
    // ...mapState('settingcheck', ['settingcheckin']),
    ...mapGetters('settingcheck', {
      settingcheckin: 'SETTINGCHECKIN'
    }),
    ...mapState('tag', ['tags'])
  },
  created () {
    const events = [
      'hotelAdded',
      'hotelRemoved',
      'allocationAdded',
      'allocationRemoved',
      'roomAdded',
      'roomRemoved'
    ]

    events.forEach(event => {
      EventBus.$on(event, (action) => {
        if (action) {
          this.getSubscribers()
        }
      })
    })
  },
  beforeDestroy () {
    this.cancelAutoUpdate()
  },
  mounted () {
    this.getSubscribers()
    this.timeout = setInterval(() => {
      this.getSubscribers()
    }, 30000)
    this.getTags()
    // this.connectSocket()
  }
}
</script>
